import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServiceService } from '../../service.service';
import { GlobalConstants } from 'src/app/global-config';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { MetaServiceService } from '../../meta-service.service';
declare var $;


@Component({
    selector: 'app-template-question-details',
    templateUrl: './template-question-details.component.html',
    styleUrls: ['./template-question-details.component.scss'] 
})
export class TemplateQuestionDetailsComponent implements OnInit {
    // url: string = 'https://www.goldenbansi.com/cview-images/templates/index.html' //iframe url
    // url: string = 'assets/welcome.png' //iframe url
    url: string = 'https://cviewsurvey.com/temp-question/' // iframe url
    urlSafe: SafeResourceUrl;
    tempData: any;
    public  server  =  GlobalConstants.apiURL;
    templateName: any;
    catID: any;
    categoryName : any;

    chatBox = true
    viewportScroller: any;
    

    // url: string = 'https://templates.surveysparrow.com/s/Customer-Satisfaction-Survey/tt-d4db24' //iframe url
    constructor(
        private router: Router, 
        private meta: Meta, 
        private title: Title, 
        private sanitizer: DomSanitizer,
        public service: ServiceService,
        private metaService: MetaServiceService
        ) {
        //  SEO Meta Description
        this.meta.addTags([
            { name: 'description', content: 'Home page of SEO friendly app' },
            { name: 'author', content: 'CViewSurvey' },
            { name: 'keywords', content: 'Angular, CViewSurvey' }
        ]);

        this.setTitle('CViewSurvey | Go on the Mobile');
        // End SEO Meta Description
    }

    // private scrollToTop(event: any): void {
    //     if (event! instanceof NavigationEnd) return;
    //     if (isPlatformServer(this.platformId)) return;
    //     let scroll = this.shouldScroll();
    //     this.viewportScroller.scrollToPosition([1080, 0]);
    // }
    
    shouldScroll() {
        throw new Error('Method not implemented.');
    }
    platformId(platformId: any) {
        throw new Error('Method not implemented.');
    }

    // SEO Page Title Description
    public setTitle(newTitle: string) {
        this.title.setTitle(newTitle);
    }

    // SEO Page Title Description
    ngOnInit() {
         // for create canonical link 
        this.metaService.createCanonicalURL();

        // other
        let category_name = window.localStorage.getItem("category_name");
        let category_id = window.localStorage.getItem("category_id");
        let template_id = window.localStorage.getItem("selected_temp_id");
        this.tempList(category_id);
        this.Questionlist(template_id) 
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url); //veiw Pannel Sanitizer 

        this.categoryName = category_name;
        console.log('test', this.categoryName)
            

    // Related-template
    // End Testimonial Top Slider
    // End-Related-template
    // console.log("Page URL", this.router.url)

    }
     
    ngAfterViewInit(){
        setTimeout(function () {
            $(".owl-carousel").each(function(){
                $(this).owlCarousel({
                  loop:true,
                  margin:10,
                  center:true,
                  nav:false,
                  autoplay:true,
                  responsive:{
                      0:{

                          items:2
                      },
                      600:{

                          items:4
                      },
                      1000:{

                          items:5
                      }
                  }
                });
              });   
            }, 1000);
    }

    tempList(id){
        this.service.template_list(id)
              .subscribe((data: any[]) => {
                this.tempData = data['data']['templates'];
                console.log(this.tempData)
               })
          error => {
              console.log('no data found');
          }
    }
 
    Questionlist(id) {
       // var isquestion = true;
        this.service.template_question_list(id).subscribe((result: any[]) => {
         // this.Questionlist = result['data'].theme_design;
        //   console.log(result["data"]);
          this.templateName = result["data"].template_title;
          this.catID = result["data"].category_id;
          this.CategoryName(this.catID)
         // this.Questionlist = result["data"];
        });
        (error) => {
          console.log("no data found");
        };
    }

    CategoryName(id){
        console.log(id)
        this.service.selected_category(id).subscribe((result: any[]) => {
        });
        (error) => {
            console.log("no data found");
        };
    }

    reload_page(template_id,category_id) {
        window.localStorage.removeItem("selected_temp_id"); 
        window.localStorage.setItem("selected_temp_id", template_id);
        window.localStorage.removeItem("category_id");
        window.localStorage.setItem("category_id", category_id);
        window.location.reload();
    }    

    category_redirect(){
        let category_id = window.localStorage.getItem("category_id");
        window.localStorage.setItem("category_id", category_id);
        this.router.navigate(['/templates']);
    } 
}



